<h1 class="page-title">Tanítások</h1>

<div *ngIf="auth.hasRole('av')">
  <a [routerLink]="['/admin/felvetelek/tanitasok/uj']"
     class="btn btn-outline-primary"
  >
    <span class="fa fa-plus"></span> Új
  </a>
</div>

<section id="sermon-list">
  <kkk-pagination
      [pagination]="pagination"
      [hideWhenOnly]="true"
      [center]="true"
      name="Tanítások listájának felső lapozója"
      (pageChangeUrl)="loadPage($event)"
  ></kkk-pagination>

  <div class="div-table my-3">
    <div class="div-table-header d-none d-md-block">
      <div class="row">
        <div class="col-md-3 col-lg-2">Dátum</div>
        <div class="col-md-3">Előadó</div>
        <div class="col-md-4 col-lg-5">Cím</div>
        <div class="col-md-2">&nbsp;</div>
      </div>
    </div>
    <div class="div-table-body">
      <div *ngIf="!sermons" class="text-center">
        <kkk-loading></kkk-loading>
      </div>
      <div class="row py-3 py-md-1" *ngFor="let sermon of sermons">
        <div class="col-md-3 col-lg-2">{{sermon.date}}</div>
        <div class="col-md-3">{{sermon.preacher}}</div>
        <div class="col-md-4 col-lg-5">{{sermon.title}}</div>
        <div class="col-md-2 mt-2 mt-md-0">
          <a class="btn btn-sm btn-success"
             href="{{sermon.file | storageLink:'sessions'}}"
             target="_blank"
          ><i class="fa fa-download" aria-label="Letöltés"></i> <span
              class="d-md-none d-lg-inline-block">Letöltés</span></a>
          <button type="button"
                  class="btn btn-sm btn-outline-danger"
                  (click)="removeSermon(sermon)"
                  *ngIf="auth.hasAnyRoleOf('admin', 'av')"
          ><span class="fa fa-trash"></span><span class="sr-only">Törlés</span></button>
        </div>
      </div>
    </div>
  </div>

  <kkk-pagination
      [pagination]="pagination"
      [hideWhenOnly]="true"
      [center]="true"
      name="Tanítások listájának alsó lapozója"
      (pageChangeUrl)="loadPage($event)"
  ></kkk-pagination>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/sermons/sermons.component.html